/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorDeleteCompositionsByIdMutationResponse, VideoEditorDeleteCompositionsByIdPathParams, VideoEditorDeleteCompositionsById401, VideoEditorDeleteCompositionsById403 } from "../models/VideoEditorDeleteCompositionsById";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { videoEditorDeleteCompositionsById } from "../axios/videoEditorDeleteCompositionsById";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const videoEditorDeleteCompositionsByIdMutationKey = () => [{ url: '/video-editor/v1/compositions/:id' }] as const

export type VideoEditorDeleteCompositionsByIdMutationKey = ReturnType<typeof videoEditorDeleteCompositionsByIdMutationKey>

export function videoEditorDeleteCompositionsByIdMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = videoEditorDeleteCompositionsByIdMutationKey()
        return mutationOptions<VideoEditorDeleteCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorDeleteCompositionsById401 | VideoEditorDeleteCompositionsById403>, {id: VideoEditorDeleteCompositionsByIdPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return videoEditorDeleteCompositionsById(id, config)
          },
        })

}

/**
 * @summary Delete a single Composition
 * {@link /video-editor/v1/compositions/:id}
 */
export function useVideoEditorDeleteCompositionsById<TContext>(options: 
{
  mutation?: UseMutationOptions<VideoEditorDeleteCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorDeleteCompositionsById401 | VideoEditorDeleteCompositionsById403>, {id: VideoEditorDeleteCompositionsByIdPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? videoEditorDeleteCompositionsByIdMutationKey()

          const baseOptions = videoEditorDeleteCompositionsByIdMutationOptions(config) as UseMutationOptions<VideoEditorDeleteCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorDeleteCompositionsById401 | VideoEditorDeleteCompositionsById403>, {id: VideoEditorDeleteCompositionsByIdPathParams["id"]}, TContext>
          

          return useMutation<VideoEditorDeleteCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorDeleteCompositionsById401 | VideoEditorDeleteCompositionsById403>, {id: VideoEditorDeleteCompositionsByIdPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<VideoEditorDeleteCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorDeleteCompositionsById401 | VideoEditorDeleteCompositionsById403>, {id: VideoEditorDeleteCompositionsByIdPathParams["id"]}, TContext>
      
}